import { Component } from 'react';
import { Link, useParams } from "react-router-dom";
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import { updateData } from './constants.js';
const moment = require('moment');

class MassCommunicationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data          :[],
      isLoading     :true,
      noMore        :true,
    };
  }

  async getMassCommunications() {
    try {
      const response = await fetch('/api/mass-communications');
      const json = await response.json();
      const flag = json.filter((item)=>item.is_read===0);
      if (flag.length>0)
        this.setState({noMore:false});
      else
        this.setState({noMore:true});
      this.setState({ data: json });
      //this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getMassCommunications();
  }

  render() {
    if(!this.state.isLoading){
      const mass_communications = this.state.data;
      var message_count = mass_communications.filter(a=> a.is_read===0);
      const mass_communication_list = mass_communications.map((mc, i)=>
        <>
          {!mc.is_read &&
            <Link key={mc.id} className="dropdown-item d-flex align-items-center" to={"/message/"+mc.id}>
                <div className="dropdown-list-image mr-3">
                  <img className="rounded-circle" src="/img/undraw_profile_1.svg" alt="..." />
                  <div className={mc.is_read?"status-indicator":"status-indicator bg-success"}></div>
                </div>
                <div className={mc.is_read?"":"font-weight-bold"}>
                    <div className="text-truncate">{mc.message}</div>
                    <div className="small text-gray-500">{mc.posted_by} · {moment(mc.created_date).startOf('hour').fromNow()}</div>
                </div>
            </Link>
          }
        </>
      );
      return(
        <>
          <a className="nav-link dropdown-toggle" href="#" id="messagesDropdown" role="button"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fas fa-envelope fa-fw"></i>

              <span className="badge badge-danger badge-counter">{message_count.length?message_count.length:""}</span>
          </a>

          <div className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="messagesDropdown">
              <h6 className="dropdown-header">
                  Message Center
              </h6>
              {mass_communication_list}
              {this.state.noMore ? <Link className="dropdown-item text-center small text-gray-500" to="#">No More Messages</Link>:
              <Link className="dropdown-item text-center small text-gray-500" to="#">Read More Messages</Link>}
          </div>
        </>
      );
    }
  }
}

class Message extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data : {},
      isLoading : true,
    };
    this.markAsRead = this.markAsRead.bind(this);
  }

  async getMessage(id) {
    try {
      const response = await fetch('/api/mass-communication/'+id);
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
      this.markAsRead();
    }
  }

  markAsRead(e) {
    if(!this.state.data.is_read && !this.state.isLoading) {
      const Id = this.state.data.id;
      updateData('/api/message-read/'+Id, {})
      .then((response) => {
          console.log(response);
      });
    }
  }

  componentDidMount() {
    if(this.props.messageId)
    this.getMessage(this.props.messageId);
  }

  // Adding componentDidUpdate to handle messageId change
  componentDidUpdate(prevProps) {
    if (prevProps.messageId !== this.props.messageId) {
      this.setState({ isLoading: true }, () => {
        this.getMessage(this.props.messageId);
      });
    }
  }

  render() {
    return(
      <>
        {!this.state.isLoading &&
          <div className="container-fluid">
            <h3 className="text-success fw-bold"> Message </h3>
              <div className="card shadow-sm my-2">
                <div className="card-body message-box">
                  <div className="my-3">
                    <div className={this.state.data.is_read?"text-right text-dark":"fw-bold text-right text-dark"}>{moment(this.state.data.created_date).format("LLL")}</div>
                    <div className={this.state.data.is_read?"text-right text-dark":"fw-bold text-right text-dark"}>{this.state.data.posted_by}</div>
                  </div>
                  <div className={this.state.data.is_read?"px-3 py-2 text-dark":"font-weight-bold px-3 py-2 text-dark"}>
                      <p>{this.state.data.message}</p>
                  </div>
                </div>
              </div>
          </div>
        }
      </>
    )
  }
}

function ViewMessage() {
  const { id } = useParams();
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <Message messageId={id} />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { ViewMessage, MassCommunicationList };
